import React from 'react';
import styled from 'styled-components';
import Radio from '../../assets/icons/radio_button.svg';
import RadioCheckedNormal from '../../assets/icons/radio_button_checked.svg';
import RadioCheckedBlue from '../../assets/icons/radio_button_checked_blue.svg';
import RadioCheckedBlueLight from '../../assets/icons/radio_button_checked_blueVA.svg';
import RadioCheckedUB from '../../assets/icons/radio_button_checked_UB.svg';

const site = process.env.REACT_APP_BUILD_SITE;

const RadioChecked = () => {
  if (site === 'CMBR') return RadioCheckedBlue;
  if (site === 'VAMX') return RadioCheckedBlueLight;
  if (site === 'UBPE') return RadioCheckedUB;
  return RadioCheckedNormal;
};

const RadioContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: ${({ marginRight }) => marginRight && `${marginRight}px`};
  margin-bottom: ${({ marginBottom }) => marginBottom && `${marginBottom}px`};
`;

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledRadio = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: ${({ checked }) => (checked ? `url(${RadioChecked()})` : `url(${Radio})`)};
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
`;

const Checkbox = ({ name, className, checked, onChange, marginRight, marginBottom, onClick, dataPanel }) => (
  <RadioContainer marginRight={marginRight} marginBottom={marginBottom} className={className} onClick={onChange}>
    <HiddenRadio name={name} checked={checked} onChange={onChange} />
    <StyledRadio checked={checked} data-panel={dataPanel} />
  </RadioContainer>
);

export default Checkbox;
